import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function ExamsCard({color,title,info,link,botonDescription,src}) {
  return (
    <div style={{backgroundColor: color}} className={`flex w-full max-h-fit rounded-tl-none rounded-30 overflow-hidden transform shadow-[-10px_10px_0px_0px_#0D2334] border-solid border-4 border-primario`}>
      <div className="flex flex-col gap-5 w-1/2  p-10 justify-center hyphens-none">
        <h3 className="text-6xl font-bold text-white font-Bebas">{title}</h3>
        <p className="hyphens-none leading-relaxed text-xl">{info}</p>
        <Link to={link} style={{color:color}} className={`rounded-30 bg-white rounded-tl-none w-max p-5 font-bold text-2xl font-Bebas`}>{botonDescription}</Link>
      </div>
      <div className="w-1/2 group overflow-hidden max-h-fit">
        <img src={src} alt={title} className=" object-cover w-full h-full group-hover:scale-110 transition duration-200" />
      </div>
    </div>
  );
}

export default ExamsCard;
